import { apiGet, apiPatch, apiPost } from './client.js';

export interface CycleCountListRow {
  id: string;
  storeId: string;
  status: string;
  countType: string;
  blindCount: boolean;
  startedAt: string;
  submittedAt: string | null;
  approvedAt: string | null;
  startedByName: string | null;
  varianceValue: number;
}

export interface CycleCountLineRow {
  id: string;
  itemId: string;
  itemName: string;
  barcodeInternal: string | null;
  expectedQty: string | null;
  countedQty: string | null;
  variance: string | null;
  varianceCost: string | null;
  binLocation: string | null;
  notes: string | null;
  accepted: boolean | null;
}

export interface CycleCountDetail {
  id: string;
  status: string;
  countType: string;
  blindCount: boolean;
  startedAt: string;
  submittedAt: string | null;
  notes: string | null;
  progress: { counted: number; total: number };
  lines: CycleCountLineRow[];
}

export function listCycleCounts() {
  return apiGet<CycleCountListRow[]>('/api/v1/inventory/counts').then((r) => r.data);
}

export function createCycleCount(body: {
  countType: 'full' | 'category' | 'location' | 'custom';
  filterCategory?: string;
  filterBinLocation?: string;
  blindCount?: boolean;
  notes?: string;
  itemIds?: string[];
}) {
  return apiPost<{ id: string; status: string }, typeof body>('/api/v1/inventory/counts', body).then((r) => r.data);
}

export function getCycleCount(id: string) {
  return apiGet<CycleCountDetail>(`/api/v1/inventory/counts/${id}`).then((r) => r.data);
}

export function patchCycleCountLine(countId: string, lineId: string, body: { countedQty: number; notes?: string }) {
  return apiPatch<{ ok: boolean }, typeof body>(`/api/v1/inventory/counts/${countId}/lines/${lineId}`, body).then(
    (r) => r.data,
  );
}

export function submitCycleCount(id: string) {
  return apiPost<{ status: string }, Record<string, never>>(`/api/v1/inventory/counts/${id}/submit`, {}).then(
    (r) => r.data,
  );
}

export function reviewCycleCountLine(countId: string, lineId: string, action: 'accept' | 'reject' | 'recount') {
  return apiPost<{ ok: boolean }, { action: typeof action }>(
    `/api/v1/inventory/counts/${countId}/lines/${lineId}/review`,
    { action },
  ).then((r) => r.data);
}

export function acceptAllVariances(countId: string) {
  return apiPost<{ ok: boolean }, Record<string, never>>(
    `/api/v1/inventory/counts/${countId}/accept-all-variances`,
    {},
  ).then((r) => r.data);
}

export function approveCycleCount(countId: string) {
  return apiPost<{ status: string }, Record<string, never>>(`/api/v1/inventory/counts/${countId}/approve`, {}).then(
    (r) => r.data,
  );
}
